import { PermissionHttpClient } from 'module/api/permission';
import { axiosInstance } from '../axios';

export const PermissionAPI = new PermissionHttpClient(axiosInstance);
